import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@material-ui/core";

import { resolveNoveltyEntry } from "./noveltyResolve";

// Punto "Nuevo" puramente visual junto al label de un tab. A propósito NO
// es interactivo (un <Tab> de MUI ya es un botón; meter otro botón dentro
// sería HTML inválido y rompe foco/lectores de pantalla) — el control
// accesible con la info real es NoveltyInfoButton, en el contenido del tab.
// Por eso el punto lleva aria-hidden: la novedad se anuncia desde ahí, no
// desde aquí.
export default function NoveltyTabDot({ anchors, noveltyWindowDays, children }) {
  const entrada = resolveNoveltyEntry(anchors, noveltyWindowDays);
  if (!entrada) return children;

  return (
    <Badge color="error" variant="dot" aria-hidden="true">
      {children}
    </Badge>
  );
}

NoveltyTabDot.propTypes = {
  anchors: PropTypes.arrayOf(PropTypes.string).isRequired,
  noveltyWindowDays: PropTypes.number,
  children: PropTypes.node.isRequired,
};
